import { ThisReceiver } from '@angular/compiler';
import { Component, ViewChild, OnInit, Input } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { timeStamp } from 'console';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { MasterDepartmentService } from 'src/app/services/master-department.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-general-subDept',
  templateUrl: './generalSubDept.component.html',
  styleUrls: ['./generalSubDept.component.scss']
})

export class generalSubDept implements OnInit {
  @ViewChild('matPaginator') matPaginator: MatPaginator;
  departments = [];
  plantId: any;
  displaySideBar: boolean = false;
  editMode: boolean = false;
  subDepartmentForm!: FormGroup;
  editSubId: any;
  subDeptDS: any;
  subDeptInput: any;
  langObj: any = {};
  subDeptArr: any[];
  languageDir = 'ltr';
  moduleId!: any;
  breadcrumList!: any;
  pageId!: any;
  IsAccess: any;
  IsWrite: any;
  subDeptColumns: string[] = ['Action', 'Plant', 'Department', 'SubDepartment'];

  constructor(
    private machineMappingService: MachineMappingService,
    private toaster: ToastrService,
    private masterDepartmentService: MasterDepartmentService,
    private userManagementService: UserManagementService,
    private platModelService: EnterPriseGroupService,
    private translater: TranslaterService,
    private translate: TranslateService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
  }

  ngOnInit(): void {
    this.GetMenuAccess();
    this.GetBreadcrumList();
    this.subDepartmentForm = new FormGroup({
      department: new FormControl('', [Validators.required]),
      subDepartment: new FormControl('', [Validators.required])
    });
  }

  public getDepartments(plantId: any): void {
    let key = {
      ptId: plantId
    };
    this.plantId = plantId;
    this.machineMappingService.getDepartmentsByPlant(key).subscribe(
      (response: any) => {
        this.departments = response;
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  gridFilterSearch(): void {
    this.subDeptDS.filter = this.subDeptInput.trim().toLowerCase();
  }

  public getSubDepartment(plantId: any): void {
    let key = {
      plantId: plantId
    }
    this.masterDepartmentService.getSubDepartment(key).subscribe(
      (response: any) => {
        this.subDeptArr = response;
        this.subDeptDS = new MatTableDataSource<any>(this.subDeptArr.reverse());
        this.subDeptDS.paginator = this.matPaginator;
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  compare(a: number | string, b: number | string, isAsc: boolean): any {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort): void {
    const data = this.subDeptArr.slice();
    if (!sort.active || sort.direction === 'asc') {
      this.subDeptDS = data;
      return;
    }

    this.subDeptDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Roles':
          return this.compare(a.Roles, b.Roles, isAsc);
        default:
          return 0;
      }
    });
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.platModelService.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
      // localStorage.setItem('GetMenuAccess', this.permisson);
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userManagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  editSubDepartment(): void {
    let key = {
      subDepartmentId: this.editSubId,
      departmentId: this.subDepartmentForm.controls.department.value,
      subDepartmentName: this.subDepartmentForm.controls.subDepartment.value
    }
    this.masterDepartmentService.editSubDepartment(key).subscribe(
      (response: any) => {
        if (response.message == "Successful") {
          this.closeSideModal();
          this.toaster.success("Sub Department Edit Successfully");
          this.getSubDepartment(this.plantId);
        }
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  deleteSubDepartment(subDeptId: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete area!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        let key = {
          subDepartmentId: subDeptId
        }
        this.masterDepartmentService.deleteSubDepartment(key).subscribe((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'Your selected area has been deleted.',
            icon: 'success',
            timer: 800,
            showConfirmButton: false,
          });
          this.getSubDepartment(this.plantId);
        },
          (error) => {
            this.toaster.error('Error', error.error.message);
          }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your selected area is safe :)', 'error');
      }
    });
  }

  getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }


  openEditModal(subDeptId: number): void {
    this.editMode = true;
    this.editSubId = subDeptId;
    var obj = this.subDeptArr.find(x => x.subDepartmentId == subDeptId);
    this.subDepartmentForm.controls.department.setValue(obj.departmentId);
    this.subDepartmentForm.controls.subDepartment.setValue(obj.subDepartmentDesc);
    this.displaySideBar = true;
  }

  addSubDepartment(): void {
    var key = {
      departmentId: this.subDepartmentForm.controls.department.value,
      plantId: this.plantId,
      subDepartmentName: this.subDepartmentForm.controls.subDepartment.value
    }
    if (this.subDeptArr.some(x => x.subDepartmentDesc.toLowerCase() == this.subDepartmentForm.controls.subDepartment.value.toLowerCase() && x.departmentId == key.departmentId)) {
      this.toaster.error("Sub Department with same Name and Parent Department already exists!", "Error");
      this.closeSideModal();
      return;
    }
    this.masterDepartmentService.addSubDepartment(key).subscribe((res) => {
      if (res.message == "Successful") {
        this.toaster.success("Sub Department Added Successfully", "Success");
        this.closeSideModal();
        this.getSubDepartment(this.plantId);
      }
    },
      (error) => {
        this.toaster.error(error.message, "Error");
      })
  }


  openSideModal(): void {
    this.editMode = false;
    this.displaySideBar = true;
  }

  closeSideModal(): void {
    this.displaySideBar = false;
    this.subDepartmentForm.reset();
  }

}